module.exports = __webpack_public_path__ + "34736292/img/at-icon.5d6fc5d8.svg";